import "core-js/modules/es.array.reverse.js";
var _dec, _class, _descriptor;
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import debounce from "lodash-es/debounce";
import { action, makeObservable, observable, runInAction } from "mobx";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import EllipsoidTerrainProvider from "terriajs-cesium/Source/Core/EllipsoidTerrainProvider";
import CesiumEvent from "terriajs-cesium/Source/Core/Event";
import Intersections2D from "terriajs-cesium/Source/Core/Intersections2D";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import Ray from "terriajs-cesium/Source/Core/Ray";
import sampleTerrainMostDetailed from "terriajs-cesium/Source/Core/sampleTerrainMostDetailed";
import isDefined from "../Core/isDefined";
import pickTriangle from "../Map/Cesium/pickTriangle";
import EarthGravityModel1996 from "../Map/Vector/EarthGravityModel1996";
import prettifyCoordinates from "../Map/Vector/prettifyCoordinates";
import prettifyProjection from "../Map/Vector/prettifyProjection";
import gridFileUrl from "../../wwwroot/data/WW15MGH.DAC";
const scratchRay = new Ray();
const scratchV0 = new Cartographic();
const scratchV1 = new Cartographic();
const scratchV2 = new Cartographic();
const scratchIntersection = new Cartographic();
const scratchBarycentric = new Cartesian3();
const scratchCartographic = new Cartographic();
const pickedTriangleScratch = {
  tile: undefined,
  intersection: new Cartesian3(),
  v0: new Cartesian3(),
  v1: new Cartesian3(),
  v2: new Cartesian3()
};
let MouseCoords = (_dec = action.bound, _class = class MouseCoords {
  constructor() {
    _defineProperty(this, "geoidModel", void 0);
    _defineProperty(this, "proj4Projection", void 0);
    _defineProperty(this, "projectionUnits", void 0);
    _defineProperty(this, "proj4longlat", void 0);
    _defineProperty(this, "accurateSamplingDebounceTime", void 0);
    _defineProperty(this, "debounceSampleAccurateHeight", void 0);
    _defineProperty(this, "tileRequestInFlight", void 0);
    _defineProperty(this, "elevation", void 0);
    _defineProperty(this, "utmZone", void 0);
    _defineProperty(this, "latitude", void 0);
    _defineProperty(this, "longitude", void 0);
    _defineProperty(this, "north", void 0);
    _defineProperty(this, "east", void 0);
    _defineProperty(this, "cartographic", void 0);
    _initializerDefineProperty(this, "useProjection", _descriptor, this);
    _defineProperty(this, "updateEvent", new CesiumEvent());
    makeObservable(this);
    this.geoidModel = new EarthGravityModel1996(gridFileUrl);
    this.proj4Projection = "+proj=utm +ellps=GRS80 +units=m +no_defs";
    this.projectionUnits = "m";
    this.proj4longlat = "+proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees +no_defs";
    this.accurateSamplingDebounceTime = 250;
    this.tileRequestInFlight = undefined;
    this.debounceSampleAccurateHeight = debounce(this.sampleAccurateHeight, this.accurateSamplingDebounceTime);
  }
  toggleUseProjection() {
    this.useProjection = !this.useProjection;
    this.updateEvent.raiseEvent();
  }
  updateCoordinatesFromCesium(terria, position) {
    if (!terria.cesium) {
      return;
    }
    const scene = terria.cesium.scene;
    const camera = scene.camera;
    const pickRay = camera.getPickRay(position, scratchRay);
    const globe = scene.globe;
    const pickedTriangle = isDefined(pickRay) ? pickTriangle(pickRay, scene, true, pickedTriangleScratch) : undefined;
    if (isDefined(pickedTriangle)) {
      // Get a fast, accurate-ish height every time the mouse moves.
      const ellipsoid = globe.ellipsoid;
      const v0 = ellipsoid.cartesianToCartographic(pickedTriangle.v0, scratchV0);
      const v1 = ellipsoid.cartesianToCartographic(pickedTriangle.v1, scratchV1);
      const v2 = ellipsoid.cartesianToCartographic(pickedTriangle.v2, scratchV2);
      const intersection = ellipsoid.cartesianToCartographic(pickedTriangle.intersection, scratchIntersection);
      let errorBar;
      if (globe.terrainProvider instanceof EllipsoidTerrainProvider) {
        intersection.height = 0;
      } else {
        const barycentric = Intersections2D.computeBarycentricCoordinates(intersection.longitude, intersection.latitude, v0.longitude, v0.latitude, v1.longitude, v1.latitude, v2.longitude, v2.latitude, scratchBarycentric);
        if (barycentric.x >= -1e-15 && barycentric.y >= -1e-15 && barycentric.z >= -1e-15) {
          const height = barycentric.x * v0.height + barycentric.y * v1.height + barycentric.z * v2.height;
          intersection.height = height;
        }
        const geometricError = globe.terrainProvider.getLevelMaximumGeometricError(pickedTriangle.tile.level);
        const approximateHeight = intersection.height;
        const minHeight = Math.max(pickedTriangle.tile.data.tileBoundingRegion.minimumHeight, approximateHeight - geometricError);
        const maxHeight = Math.min(pickedTriangle.tile.data.tileBoundingRegion.maximumHeight, approximateHeight + geometricError);
        const minHeightGeoid = minHeight - (this.geoidModel ? this.geoidModel.minimumHeight : 0.0);
        const maxHeightGeoid = maxHeight + (this.geoidModel ? this.geoidModel.maximumHeight : 0.0);
        errorBar = Math.max(Math.abs(approximateHeight - minHeightGeoid), Math.abs(maxHeightGeoid - approximateHeight));
      }
      const terrainProvider = globe.terrainProvider;
      this.cartographicToFields(intersection, errorBar);
      if (!(terrainProvider instanceof EllipsoidTerrainProvider)) {
        this.debounceSampleAccurateHeight(terrainProvider, intersection);
      }
    } else {
      runInAction(() => {
        this.elevation = undefined;
        this.utmZone = undefined;
        this.latitude = undefined;
        this.longitude = undefined;
        this.north = undefined;
        this.east = undefined;
      });
      this.updateEvent.raiseEvent();
    }
  }
  updateCoordinatesFromLeaflet(terria, mouseMoveEvent) {
    if (!terria.leaflet) {
      return;
    }
    const latLng = terria.leaflet.map.mouseEventToLatLng(mouseMoveEvent);
    const coordinates = Cartographic.fromDegrees(latLng.lng, latLng.lat, 0, scratchCartographic);
    this.cartographicToFields(coordinates);
  }
  cartographicToFields(coordinates, errorBar) {
    this.cartographic = Cartographic.clone(coordinates, scratchCartographic);
    const latitude = CesiumMath.toDegrees(coordinates.latitude);
    const longitude = CesiumMath.toDegrees(coordinates.longitude);
    if (this.useProjection) {
      const prettyProjection = prettifyProjection(longitude, latitude, this.proj4Projection, this.proj4longlat, this.projectionUnits);
      this.utmZone = prettyProjection.utmZone;
      this.north = prettyProjection.north;
      this.east = prettyProjection.east;
    }
    const prettyCoordinate = prettifyCoordinates(longitude, latitude, {
      height: coordinates.height,
      errorBar: errorBar
    });
    this.latitude = prettyCoordinate.latitude;
    this.longitude = prettyCoordinate.longitude;
    this.elevation = prettyCoordinate.elevation;
    this.updateEvent.raiseEvent();
  }
  sampleAccurateHeight(terrainProvider, position) {
    if (this.tileRequestInFlight) {
      // A tile request is already in flight, so reschedule for later.
      this.debounceSampleAccurateHeight.cancel();
      this.debounceSampleAccurateHeight(terrainProvider, position);
      return;
    }
    const positionWithHeight = Cartographic.clone(position);
    const geoidHeightPromise = this.geoidModel ? this.geoidModel.getHeight(position.longitude, position.latitude) : undefined;
    const terrainPromise = sampleTerrainMostDetailed(terrainProvider, [positionWithHeight]);
    this.tileRequestInFlight = Promise.all([geoidHeightPromise, terrainPromise]).then(result => {
      const geoidHeight = result[0] || 0.0;
      this.tileRequestInFlight = undefined;
      if (Cartographic.equals(position, this.cartographic)) {
        position.height = positionWithHeight.height - geoidHeight;
        this.cartographicToFields(position);
      } else {
        // Mouse moved since we started this request, so the result isn't useful.  Try again next time.
      }
    }).catch(() => {
      this.tileRequestInFlight = undefined;
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "useProjection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggleUseProjection", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "toggleUseProjection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCoordinatesFromCesium", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCoordinatesFromCesium"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCoordinatesFromLeaflet", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCoordinatesFromLeaflet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartographicToFields", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cartographicToFields"), _class.prototype), _class);
export { MouseCoords as default };